<template>
    <el-container direction="vertical" class="card task-card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка задачи
                </div>
                <div class="employer-id grey">
                    ID {{ task.id }}
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </span>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start" class="card-general">
                <el-row class="mb25">
                    <el-col :span="24" class="bold fnt-mid2">
                        {{ task.title }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Статус:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ statusName }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Приоритет:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        <span :class="[priorityColor]">{{ priorityName }}</span>
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Дата создания:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ task.created_at }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Выполнить до:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ task.planned }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Сделка или лид:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        <template v-if="issetRelatedEntity">
                            <div class="link" @click="goRelatedEntity()">
                                {{ task.related_entity_id }}
                            </div>
                        </template>
                    </el-col>
                </el-row>
                <el-row class="mb25 wauto">
                    <el-col :span="7" class="label">
                        <span class="bold">
                            Постановщик:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ createdUserName }}
                    </el-col>
                </el-row>
                <el-row class="mb25 wauto">
                    <el-col :span="7" class="label">
                        <span class="bold">
                            Исполнитель:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ assignedUserName }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Дата завершения:
                        </span>
                    </el-col>
                    <el-col :span="17">
                        {{ task.finished }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="7">
                        <span class="bold">
                            Файлы:
                        </span>
                    </el-col>
                    <el-col :span="17" class="task-card-files">
                        <el-tag
                            v-for="file in task.files"
                            :key="file.id"
                            :type="''"
                            size="mini"
                            class="pointer"
                            @click.native="handleTagClick(file)"
                            :disable-transitions="true"
                        >
                            {{ file.name }}
                        </el-tag>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="16" class="card-comment">
                <span class="bold">
                    Комментарии:
                </span>
                <scrolly class="task-comments fnt-16" v-if="task.commentaries">
                    <scrolly-viewport>
                        <div
                            v-for="commentDate in Object.keys(task.commentaries)"
                            :key="commentDate"
                            class="day"
                        >
                            <div class="title-date">
                                {{ getCommentDate(commentDate) }}
                            </div>
                            <div
                                v-for="comment in task.commentaries[commentDate]"
                                :key="comment.id"
                            >
                                <div class="comment">
                                    <span class="name">
                                        {{ comment.employer ? comment.employer.full_name : 'неизвестен' }}
                                    </span>
                                    <span class="time">
                                        {{ comment.created_time }}
                                    </span>
                                </div>
                                <div class="text" v-html="prepareText(comment.text)">
                                </div>
                            </div>
                        </div>
                    </scrolly-viewport>
                    <scrolly-bar axis="y" />
                </scrolly>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import moment from 'moment';
import { formatText } from '@/common/utilities';
import FileSaver from 'file-saver';
import localReferences from '@/helpers/localReferences';
import '@/assets/styles/card.scss';

library.add(faCheck);

export default {
    name: 'TasksCard',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    components: {
        Scrolly,
        ScrollyViewport,
        ScrollyBar
    },
    data() {
        return {
            loading: true,
            task: {},
            today: moment().format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'day').format('YYYY-MM-DD')
        };
    },
    beforeMount() {
        this.$store.dispatch('tasks/getTask', this.id).then(
            response => {
                this.loading = false;
                this.task = response.data.data;
            },
            error => {
                if (error.response.status === 403) {
                    console.log(error.response.data.error);
                    this.loading = false;
                    this.$router.push({ name: 'tasks' });
                }
            }
        );
    },
    mounted() {
        moment.locale('ru');
    },
    computed: {
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => this.approvedRoles.includes(x));

            return intersection.length > 0;
        },
        issetRelatedEntity() {
            return this.task.related_entity_id > 0;
        },
        approvedRoles() {
            return this.$store.getters['references/rolesBySectionTask'];
        },
        statusName() {
            return this.task.status ? this.task.status.name : '';
        },
        priorityName() {
            let priorityName = 'Неизвестно';
            switch (this.task.priority) {
                case localReferences.taskPriorities.low:
                    priorityName = 'Низкий';
                    break;
                case localReferences.taskPriorities.middle:
                    priorityName = 'Средний';
                    break;
                case localReferences.taskPriorities.high:
                    priorityName = 'Высокий';
                    break;
            }
            return priorityName;
        },
        priorityColor() {
            let priorityClass = '';
            switch (this.task.priority) {
                case localReferences.taskPriorities.low:
                    priorityClass = '';
                    break;
                case localReferences.taskPriorities.middle:
                    priorityClass = 'light-blue';
                    break;
                case localReferences.taskPriorities.high:
                    priorityClass = 'light-red';
                    break;
            }
            return priorityClass;
        },
        createdUserName() {
            return this.task.created_user ? this.task.created_user.full_name : '';
        },
        assignedUserName() {
            return this.task.assigned_user ? this.task.assigned_user.full_name : '';
        }
    },
    methods: {
        edit() {
            if (this.canEdit) {
                this.$router.push({ name: 'task-card-edit', params: { id: '' + this.id } });
            }
        },
        close() {
            this.$router.push({ name: 'tasks' });
        },
        goContactNew() {
            if (this.canEdit) {
                this.$router.push({ name: 'task-card-new', params: { taskId: '' + this.id } });
            }
        },
        goContact(id) {
            if (this.canEdit) {
                this.$router.push({ name: 'task-card', params: { id: '' + id } });
            }
        },
        goRelatedEntity() {
            if (this.task.related_entity_type === 'lead') {
                this.$router.push({ name: 'lead-card', params: { id: this.task.related_entity_id } });
            } else if (this.task.related_entity_type === 'deal') {
                this.$router.push({ name: 'deal-card', params: { id: this.task.related_entity_id } });
            }
        },
        handleTagClick(tag) {
            this.$store.dispatch('tasks/getFile', tag.id).then(response => {
                FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
            }).catch(error => {
                console.log(error);
            });
        },
        prepareText(text) {
            return formatText(text);
        },
        getCommentDate(date) {
            if (date === this.today) {
                return 'Сегодня';
            }
            if (date === this.yesterday) {
                return 'Вчера';
            }
            return moment(date).format('D MMMM');
        }
    }
};
</script>
